// extracted by mini-css-extract-plugin
export var divider = "_kk-0";
export var systemMessage = "_kk-1";
export var systemMessageWrapper = "_kk-2";